<h1 mat-dialog-title [attr.translate]="'no'">{{'refreshTokenDialogHeader' | translate}}</h1>
<h3 [attr.translate]="'no'">{{'refreshTokenDialogBody' | translate}}</h3>
<div mat-dialog-actions [attr.translate]="'no'">
  <button mat-raised-button color="primary" [mat-dialog-close]="true" class="c-white next-btn"
    style="font-style: rgb(255, 255, 255);">
    {{('yes' | translate | uppercase)}}</button>
  <button mat-raised-button (click)="closeDialog()" class="back-btn">{{('cancel' | translate | uppercase)}}</button>
</div>